import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import MainContainer from "../../layout/MainContainer";
import { DocumentViewer } from "../../components";
import {
  Challenges,
  Details,
  Earning,
  Journeys,
  PostsAndStories,
  TutorRating,
} from "../../features";
import {
  useLazyGetTeachingDetailsByIdQuery,
  useLazyGetTutorDetailsQuery,
  useLazyGetnextTutorByIdQuery,
  useLazyGetutorByIdQuery,
} from "../../services/tutor";
import { EmbedPDF } from "@simplepdf/react-embed-pdf";

import Loader from "../../helpers/Loader";
import { TutorDetails } from "../../types/General";
import { useLazyGetDocucmentsDetailsQuery } from "../../services/documentation";
import moment from "moment";
import { errorToast } from "../../helpers";
import { useLazyGetFormsByIdQuery } from "../../services/forum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface VideoDetails {
  _id: string;
  images: string[];
  title: string;
  topic: string;
  description: string;
  allowComments: boolean;
  views: number;
  contentStatus: number;
  isAnonymous: boolean;
  status: boolean;
  createdAt: string;
  subjects: [
    {
      name: string;
    },
  ];
  grades: {
    name: string;
  };
  user: {
    _id: string;
    name: string;
    userName: string;
    email: string;
    phoneNo: string;
    dialCode: string;
    image: string;
  };
}

const TeaserVideoDetails = () => {
  const navigate = useNavigate();
  const [img, setImg] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const { _id } = useParams();
  const [getDocs] = useLazyGetDocucmentsDetailsQuery();
  const [teaserVideo] = useLazyGetFormsByIdQuery();
  const [videoDetails, setVideoDetails] = useState<VideoDetails | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await teaserVideo({ id: _id }).unwrap();
      if (response.statusCode === 200) {
        setVideoDetails(response.data);
      }
    } catch (error) {
      console.error(error);
      errorToast("Failed to fetch video details");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [_id]);

  if (loading) {
    return <Loader />;
  }

  if (!videoDetails) {
    return <Typography>No video details found</Typography>;
  }

  const videoAvailability = videoDetails.isAnonymous ? "Anonymous" : "Everyone";
  const formattedDate = moment(videoDetails.createdAt).format(
    "MMMM Do YYYY, h:mm:ss a"
  );

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Short Video Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-videos");
            }}
          >
            Back
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item xs={12}>
                <Typography component="h5">Video</Typography>
                <figure>
                  {videoDetails.images.length > 0 ? (
                    <video
                      style={{
                        marginLeft: -35,
                        height: 150,
                        width: 250,
                      }}
                      controls
                      muted
                      autoPlay
                      src={videoDetails.images[0]}
                    />
                  ) : (
                    <Typography>No video available</Typography>
                  )}
                </figure>
              </Grid>

              <Grid item xs={10} className="view_box_list">
                <Grid container spacing={3}>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Name</Typography>
                      <Typography component="p">
                        {videoDetails.user.name || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Username</Typography>
                      <Typography component="p">
                        {videoDetails.user.userName || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Email</Typography>
                      <Typography component="p">
                        {videoDetails.user.email || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Phone no</Typography>
                      <Typography component="p">
                        {videoDetails.user.dialCode}{" "}
                        {videoDetails.user.phoneNo || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Subject</Typography>
                      <Typography component="p">
                        {videoDetails.subjects[0]?.name || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Grade</Typography>
                      <Typography component="p">
                        {videoDetails.grades?.name || "-"}
                      </Typography>
                    </Box>
                  </Grid> */}
                  {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Topic</Typography>
                      <Typography component="p">
                        {videoDetails.topic || "-"}
                      </Typography>
                    </Box>
                  </Grid> */}

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Title</Typography>
                      <Typography component="p">
                        {videoDetails.title || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Video Availability</Typography>
                      <Typography component="p">{videoAvailability}</Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Created At</Typography>
                      <Typography component="p">{formattedDate}</Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Views</Typography>
                      <Typography component="p">
                        {videoDetails.views}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Allow Comments</Typography>
                      <Typography component="p">
                        {videoDetails.allowComments ? "Yes" : "No"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h5">Custom Notes</Typography>
                      <Typography
                        component="div"
                        dangerouslySetInnerHTML={{
                          __html: videoDetails?.description || "-",
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
      <DocumentViewer open={open} setOpen={setOpen} img={img} />
    </MainContainer>
  );
};
export default TeaserVideoDetails;
